import React from 'react'
import {ParagraphText, Radio} from '@thryvlabs/maverick'

function OnboardingRequired({onboardingRequired, setOnboardingRequired}) {
  const handleOnboardingRequiredChange = ({target: {value}}) => {
    setOnboardingRequired(prevState => ({...prevState, value}))
  }

  const selectedValue = onboardingRequired?.value ?? onboardingRequired
  const isNo = selectedValue === 'No'

  return (
    <div className="d-flex flex-column" style={{rowGap: '30px'}}>
      <div>
        <ParagraphText variant="reg" className="text-left">
          {'Do you want to add onboarding?'}
        </ParagraphText>
        <div className="d-flex gap-3">
          <Radio
            hasLabel
            id="Yes"
            name="onboardingRequired"
            value="Yes"
            label="Yes"
            toggled={selectedValue === 'Yes'}
            handleOnChange={handleOnboardingRequiredChange}
          />
          <Radio
            hasLabel
            id="No"
            name="onboardingRequired"
            value="No"
            label="No"
            toggled={selectedValue === 'No'}
            handleOnChange={handleOnboardingRequiredChange}
          />
        </div>
        {isNo && (
          <div
            className="d-flex align-items-start"
            style={{
              columnGap: '8px',
              marginTop: '8px',
              backgroundColor: '#1C3557',
              borderRadius: '6px',
              padding: '10px 12px',
            }}
          >
            <span
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: '16px',
                height: '16px',
                borderRadius: '50%',
                border: '1.5px solid #FFFFFF',
                fontSize: '10px',
                fontWeight: 'bold',
                color: '#FFFFFF',
                marginTop: '2px',
                flexShrink: 0,
              }}
            >
              i
            </span>
            <ParagraphText
              variant="sm"
              className="m-0"
              style={{color: '#FFFFFF'}}
            >
              An appointment is still required for Professionally Designed
              Website and/or Value Added Services
            </ParagraphText>
          </div>
        )}
      </div>
    </div>
  )
}

export {OnboardingRequired}
